<script setup>
const anneeCourante = new Date().getFullYear();
</script>

<template>
    <footer class="footer">
        <div class="lg:hidden">
            <img class="w-full" src="../assets/img/shapes/mobile-footer.svg" />
        </div>

        <hr class="my-12 md:mb-2 md:my-0" />

        <div class="text-gray text-sm block px-4 md:px-8 py-4 flex flex-col-reverse md:flex-row md:justify-between">
            <div class="mb-2 flex md:text-center flex-row mt-12 md:mt-auto">
                <span class="mr-1">©{{anneeCourante}} Opéra Énergie.</span>
                <span class="md:hidden">Tous droits réservés</span>
                <span class="hidden md:inline">Immatriculation - SIREN : 808096119</span>
            </div>
            <div class="flex flex-col md:flex-row gap-4 md:text-center">
                <a
                    class="hover:underline"
                    href="https://opera-energie.com/conditions-generales-dutilisation/"
                >
                    Conditions générales d'utilisation
                </a>
                <a
                    class="hover:underline"
                    href="https://opera-energie.com/politique-de-confidentialite/"
                >
                    Politique de confidentialité
                </a>
                <a
                    class="hover:underline"
                    href="https://legals.opera-energie.com/fonctionnement-service/"
                >
                    Fonctionnement du service
                </a>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
.text-gray {
    color: $gris-tvt-6
}
</style>
